import * as React from "react";
export const renderEventsCount = (count, componentPrefix) => {
    return (React.createElement("div", { className: `rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__events-count` },
        React.createElement("span", { className: `rj-ev-list__${componentPrefix}__count` }, count)));
};
//# sourceMappingURL=renderEventsCount.js.map